<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define sections
const sections = [
  { id: 'gestion-informacion', title: '7.1 Instrumentos de gestión de la información' },
  { id: 'datos-abiertos', title: '7.2 Sección de Datos Abiertos' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="7. Datos Abiertos" />
</template>
